
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {LanguagesOutput, PromotionsOutputOriginalType } from '../../types/generic';

export default  {
 
    
    languages(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< LanguagesOutput >("GET",`${config.apiUrl.generic}/GenericQuery/Languages${queryParams || ""}`,undefined, options);
    },
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.generic}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.generic}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },
 
    
    promotions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< PromotionsOutputOriginalType >("GET",`${config.apiUrl.generic}/PromotionsQuery/Promotions${queryParams || ""}`,undefined, options);
    },

};